import { Injectable, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class UtilityService {

  constructor(private sanitizer: DomSanitizer) {}

  sanitizeUrl(url: string): string | null {
    if (!url) return null;
    const sanitized = this.sanitizer.sanitize(SecurityContext.URL, url);
    
    // If sanitized result starts with 'unsafe:', it's not a valid safe URL
    if (sanitized && sanitized.startsWith('unsafe:')) {
      return null;
    }

    return sanitized;
  }

  public getSubDomainFromUrl() {
    const hostname = window.location.hostname;
    const hostnameWithoutProtocol = hostname.replace(/(^\w+:|^)\/\//, '');
    const parts = hostnameWithoutProtocol.split('.');
    if (parts.length > 1) {
      return parts[0];
    }
    return null;
  }

  public getParamValueFromAnyUrl(key: string): string | null {
    const hash = window.location.hash;
    const queryStart = hash.indexOf('?');

    if (queryStart === -1) return null;

    const outerQuery = hash.substring(queryStart + 1);
    const outerParams = new URLSearchParams(outerQuery);

    // 1. Check directly in outer query
    if (outerParams.has(key)) {
      return outerParams.get(key);
    }

    // 2. Check inside redirect query string
    const redirectUrl = outerParams.get('redirect');
    if (redirectUrl && redirectUrl.includes('?')) {
      const innerQuery = redirectUrl.split('?')[1];
      const innerParams = new URLSearchParams(innerQuery);
      return innerParams.get(key);
    }

    return null;
  }

  public paramExistsInAnyUrl(key: string): boolean {
    const hash = window.location.hash;
    const queryStart = hash.indexOf('?');

    if (queryStart === -1) return false;

    const outerQuery = hash.substring(queryStart + 1);
    const outerParams = new URLSearchParams(outerQuery);

    // 1. Check directly in outer query
    if (outerParams.has(key)) {
      return true;
    }

    // 2. Check inside redirect query string
    const redirectUrl = outerParams.get('redirect');
    if (redirectUrl && redirectUrl.includes('?')) {
      const innerQuery = redirectUrl.split('?')[1];
      const innerParams = new URLSearchParams(innerQuery);
      return innerParams.has(key);
    }

    return false;
  }

  public parseQueryParams(queryString: string): { [key: string]: string } {
    return queryString
      .split('&')
      .map(param => param.split('='))
      .reduce((params, [key, value]) => {
        params[key] = decodeURIComponent(value || '');
        return params;
      }, {} as { [key: string]: string });
  };
}
